import { useAuth } from "../auth/AuthContext";

export default function SignOutButton() {
  const { signOut } = useAuth();
  return (
    <button className="button-secondary" onClick={signOut}>
      Sign out / Clear data
    </button>
  );
}
